<template>
  <div v-if="userData">
    <div v-if="userData.perfilId !== 1">
      <Title :showService="true" :showMinister="true" />
    </div>

    <b-row>
      <div class="text">
        <h3 class="h3">ESCRITORIO DE GESTIÓN VIRTUAL</h3>
        <h5 v-if="servicio" class="h5">{{ servicio.servicio }}</h5>
      </div>
    </b-row>

    <div class="mains">
      <GroupButtons :userData="userData" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Title from "../../../components/private/Title";
import GroupButtons from "./GroupButtons.vue";
export default {
  components: {
    Title,
    GroupButtons,
  },
  data() {
    return {
      servicio: null
    }
  },
  props: ["userData"],
  methods: {
    reqData: async function() {
      try {
        const ser = await axios.get(`${process.env.VUE_APP_RUTA_API}/instituciones/servicios/${this.userData.servicioId}/retrieve_public/`);
        const minis = await axios.get(`${process.env.VUE_APP_RUTA_API}/instituciones/ministerios/${ser.data.ministerio.id}`);

        this.servicio = {
          servicio: ser.data.nombre,
          ministerio: minis.data.nombre
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  watch: {
    userData: function() {
      this.reqData();
    },
  },
  mounted() {
    
  }
};
</script>

<style scoped>
.row {
  margin: 0;
  background: #e0e0e0;
}

.text {
  text-align: center;
  margin: 15px 0;
}

.h3 {
  color: #515151;
  font-weight: 400;
  margin: 0 !important;
  font-size: 22px;
}

.h5 {
  color: #052333;
  font-weight: bold;
  margin: 0 !important;
}

@media screen and (max-width: 385px) {
  .h3 {
    font-size: 20px;
  }

  .h5 {
    font-size: 14px;
  }
}
</style>
